import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { me } from "constants/Client";
import { ROLES } from "common/ComponentAccess";

/**
 * Authmiddleware component.
 *
 * This component is used to secure routes. When a protected route is accessed,
 * it will check if the user is logged in. If not, it will redirect to the login
 * page. If the user is logged in, it will render the component passed as a prop.
 *
 * @param {Object} props - Component props
 * @param {React.Component} props.component - Component to render when the route is accessed
 * @param {React.Component} props.layout - Layout component to wrap the rendered component with
 * @param {boolean} props.isAuthProtected - Flag to determine if the route is protected
 * @param {boolean} props.isOpenRoute - Flag to determine if the route is open to everyone
 */
const Authmiddleware = ({ component: Component, layout: Layout, isAuthProtected, isOpenRoute, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem("authUser")) {
        return <Redirect to={{ pathname: "/staff-login", state: { from: props.location } }} />;
      }

      // redirect to home according to role
      if (localStorage.getItem("authUser")) {
        if (me() === ROLES.SUPER_ADMIN) {
          <Redirect to={{ pathname: "/superadmin", state: { from: props.location } }} />;
        }
        if (me() === ROLES.STAFF) {
          <Redirect to={{ pathname: "/staff-view", state: { from: props.location } }} />;
        }
      }

      // redirect to home when already logged-in when hitting public routes
      if (!isAuthProtected && localStorage.getItem("authUser") && !isOpenRoute) {
        return <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
};

export default Authmiddleware;
